(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marberry-announcement"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('marberry-announcement'))customElements.define('marberry-announcement',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const items=[...this.querySelectorAll('p')];let index=0;const show=n=>{index=(n+items.length)%items.length;items.forEach((p,i)=>p.hidden=i!==index);};this.querySelector('[data-prev]').addEventListener('click',()=>show(index-1));this.querySelector('[data-next]').addEventListener('click',()=>show(index+1));}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marberry-slideshow"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('marberry-slideshow'))customElements.define('marberry-slideshow',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const rail=this.querySelector('.mb-slides');const slides=[...this.querySelectorAll('.mb-slide')];const dots=[...this.querySelectorAll('[data-slide]')];let index=0;const go=n=>{index=(n+slides.length)%slides.length;rail.scrollTo({left:index*rail.clientWidth});};this.querySelector('[data-prev]').addEventListener('click',()=>go(index-1));this.querySelector('[data-next]').addEventListener('click',()=>go(index+1));dots.forEach(d=>d.addEventListener('click',()=>go(Number(d.dataset.slide))));rail.addEventListener('scroll',()=>{index=Math.round(rail.scrollLeft/rail.clientWidth);dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===index)));});rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();go(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();go(index-1);}});}});

  } catch(e) { console.error(e); }
})();
})();
